
import { GameState, GameStatistics } from './GameContextTypes';

export const initialStatistics: GameStatistics = {
  totalDecisionsMade: 0,
  successfulDecisions: 0,
  challengesCompleted: 0,
  totalTimePlayed: 0,
  sessionsPlayed: 0,
  highestLevel: 'Junior',
  rolesPlayed: [],
  skillsUnlocked: 0,
  achievementsEarned: 0,
  lastPlayedDate: new Date().toISOString(),
};

export const initialGameState: GameState = {
  gameStarted: false,
  selectedRole: null,
  careerLevel: 'Junior',
  careerPath: 'Standard',
  careerTitle: '',
  skills: [],
  experience: 0,
  yearsPassed: 1,
  kpis: {
    uptime: 95,
    energyCost: 0.08,
    profitMargin: 15,
    efficiency: 70,
  },
  achievements: [],
  currentChallenge: null,
  currentSpecialEvent: null,
  decisionHistory: [],
  hasTutorialCompleted: false,
  isSimulationComplete: false,
  settings: {
    difficulty: 'Normal',
    gameSpeed: 1,
    tutorialEnabled: true,
    autoSave: true,
    soundEnabled: true,
    yearDuration: 180,
  },
  completedChallenges: [],
  statistics: initialStatistics,
};
